import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Tab } from "semantic-ui-react";
import _, {get} from "lodash";
import SearchResultHeader from "./SearchResultHeader";
import getPersonName from "../common/Name";
import Address from "./Address";
import { getPhoneCarrierImage } from "./ListingDetails";
import { getPhoneImage, getAddressPhoneType } from "./PhoneHeader";
import PersonSearchResult from "./PersonSearchResult";
import { getMenuItem } from "../common/PageHelper";
import formatUSPhone from "../../utils/phoneUtil";

class PhoneNumberToNameNimbusResult extends Component {
  getPhoneHeader = (props) => (
    <Table.Row key={`row_phone_header_${props.index}`}>
      <Table.Cell colSpan={2}>
        {getPhoneImage(get(props.node, `addresses[0].address[0].phonesAtAddress[0].phone[0].carrierType[0]._`))}
        {formatUSPhone(` ${get(props.node, `addresses[0].address[0].phonesAtAddress[0].phone[0].phoneNumber[0]._`, "")} `)}
        &nbsp;
        {getAddressPhoneType(get(props.node, "source[0]._"))}
      </Table.Cell>
    </Table.Row>
  );

  getCarrierInfo = (props) => {
      const addressNodes = get(props.node, "addresses[0].address");
      const addressRows = [];
      _.forEach(addressNodes, (addressNode, index) => {
        const phoneNodes = get(addressNode, "phonesAtAddress[0].phone");
        let phNodeIndex = 0;
        _.forEach(phoneNodes, (phoneNode, phIndex) => {
          const carrierName = get(phoneNode, "carrier[0]._", "");
          const carrierImageName = getPhoneCarrierImage(carrierName);
          if(carrierName !== "") {
            addressRows.push(
                <Table.Row
                  key={`Carrier_Lookup_Name_Row_${index}_${phIndex}`}
                  className={phNodeIndex % 2 === 0 ? props.colorClass : ""}
                >
                  <Table.Cell>
                    <ul>
                      <li className="noBullet">
                        {carrierImageName !== "" && (
                          <img
                            key={`img_carrier`}
                            src={getPhoneCarrierImage(carrierName)}
                            alt="carrierImage"
                            width="32px"
                            height="32px"
                          />
                        )}
                        {carrierName}
                      </li>
                      <li className="noBullet">
                        {_.get(phoneNode, "county[0]._", "")}
                      </li>
                      <li className="noBullet">{`${_.get(
                        phoneNode,
                        "city[0]._",
                        ""
                      )} ${_.get(phoneNode, "state[0]._", "")}`}</li>
                      <li className="noBullet">{_.get(
                        phoneNode,
                        "listingName[0]._",
                        ""
                      )}</li>
                      <li className="noBullet">
                        {formatUSPhone(_.get(phoneNode, "phoneNumber[0]._", ""))}
                      </li>
                    </ul>
                  </Table.Cell>
                </Table.Row>);
              phNodeIndex += 1; 
            }
          });
      });
      return (
        <Table>
          <Table.Body>
            <Table.Row>
              <Table.HeaderCell>
                Carrier Contact/Subpoena Information
              </Table.HeaderCell>
            </Table.Row>
            {addressRows}
          </Table.Body>
        </Table>
      );
  }

  getPhoneDetails = (props) => {
  const lastName = _.get(props.node, "names[0].name[0].lastName[0]._", "");
  return (
    <Table.Row key={`Listing_Row_${props.index}`}>
      <Table.Cell>
        <Table key={`Listing_Table_${props.index}`} className={`sub-table`}>
          <Table.Body>
            {this.getPhoneHeader(props)}
            <Table.Row>
              <Table.Cell>
                <Table>
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell className={"sub-table-cell"}>
                        Name:
                      </Table.Cell>
                      {lastName !== "" ? (
                        <Table.Cell className={"sub-table-cell"}>
                          {getPersonName(
                            _.get(props.node, "names[0].name[0].firstName[0]._", ""),
                            "",
                            lastName,
                            props
                          )}
                        </Table.Cell>
                      ) : (
                        _.get(props.node, "listingName[0]._", "")
                      )}
                    </Table.Row>
                    <Table.Row className={"table-no-border"}>
                      <Table.Cell className={"sub-table-cell"}>
                        Address:
                      </Table.Cell>
                      <Table.Cell className={"sub-table-cell"}>
                        {<Address addressNode={get(props.node, "addresses[0].address[0]")} {...props} />}
                      </Table.Cell>
                    </Table.Row>
                    {/* <Table.Row className={"table-no-border"}>
                      <Table.Cell className={"sub-table-cell"}>
                        SMS Address:
                      </Table.Cell>
                      <Table.Cell className={"sub-table-cell"}>
                        {_.get(props.node, "carrier247[0].sms[0]._", "")}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row className={"table-no-border"}>
                      <Table.Cell className={"sub-table-cell"}>
                        MMS Address:
                      </Table.Cell>
                      <Table.Cell className={"sub-table-cell"}>
                        {_.get(props.node, "carrier247[0].mms[0]._", "")}
                      </Table.Cell>
                    </Table.Row> */}
                  </Table.Body>
                </Table>
              </Table.Cell>
              {/* <Table.Cell>{getHistoricalCarrier(props)}</Table.Cell> */}
            </Table.Row>
            <Table.Row>
              <Table.Cell>{this.getCarrierInfo(props)}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Table.Cell>
    </Table.Row>
  );
};

  render() {
    const results = [];
    let recCount = 0;
    let tabHeader = null;
    let hasPersons;
    let criteria;
    if (
      this.props.searchResultData !== undefined &&
      this.props.searchResultData !== null &&
      this.props.searchResultData !== ""
    ) {
      const listingsRecord = _.get(
        this.props.searchResultData,
        `${
          Object.keys(this.props.searchResultData)[0]
        }.persons[0]`
      );
      const log = _.get(
        this.props.searchResultData,
        `${Object.keys(this.props.searchResultData)[0]}.log[0]`
      );
      if (listingsRecord) {
        const records = _.get(listingsRecord, "person");

        const orderedListings = _.orderBy(
          records,
          ["source[0]._", "addressType[0]._"],
          ["desc", "desc"]
        );

        const showNarrowSearchMessage = records && records.length > 25;
        tabHeader = (
          <SearchResultHeader
            showNarrowSearchMessage={showNarrowSearchMessage}
            log={log}
            {...this.props}
            printContent={this.props.printContent}
          />
        );

        if (orderedListings !== undefined) {
          _.forEach(orderedListings, (record, index) => {
            const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
            results.push(
              this.getPhoneDetails({
                node: record,
                colorClass,
                ...this.props,
                index,
              })
            );
          });
        }
      }
      recCount = results.length;
      if (results.length < 1) {
        results.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={100}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
      hasPersons = _.get(
        this.props.searchResultData,
        `${
          Object.keys(this.props.searchResultData)[0]
        }.match[0].searchBy[0].persons[0]`
      );
      const actDesc = _.get(log, "actDesc[0]");
      if (actDesc !== undefined)
        if (actDesc.indexOf("with") !== -1)
          criteria = actDesc.substring(0, actDesc.indexOf("with"));
        else criteria = actDesc;
    }
    const tabs = [];
    const { userAccount } = this.props;
    tabs.push({
      menuItem: getMenuItem(
        userAccount.acctTheme,
        true,
        `${recCount} Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          {tabHeader}
          <Table stackable>
            <Table.Body>{results}</Table.Body>
          </Table>
          {hasPersons && (
            <PersonSearchResult
              {...this.props}
              isSubSection
              titleDesc={criteria}
              resultRootNodeName={`${
                Object.keys(this.props.searchResultData)[0]
              }`}
              searchResultData={_.get(
                this.props.searchResultData,
                `${
                  Object.keys(this.props.searchResultData)[0]
                }.match[0].searchBy`
              )}
            />
          )}
        </Tab.Pane>
      ),
    });

    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return {
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, null)(PhoneNumberToNameNimbusResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/PhoneNumberToNameNimbusResult.js